import { render, staticRenderFns } from "./CreateRequestReturnMaterial.vue?vue&type=template&id=4275f1d2"
import script from "./CreateRequestReturnMaterial.vue?vue&type=script&lang=js"
export * from "./CreateRequestReturnMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports